export const MAX_IMAGE_SIZE = 1024 * 1024 * 10;
export const ALLOWED_IMAGE_EXTENSIONS = ['image/png', 'image/jpg', 'image/jpeg'];
export const MAX_NAME_LENGTH = 200;
export const MAX_DESCRIPTION_LENGTH = 100;
